"use client";

import { createAuthService } from "@/shared/api/services/authService";
import { useBuyerService } from "@/shared/auth/hooks";

export function useAuthService() {
  return useBuyerService(createAuthService);
}
